const ConfigDataType = Object.freeze({
  Member: 1,
  Team: 2,
  All: 3,
  NonNatca: 4,
});
export default ConfigDataType;
